<!-- 人工叫料材料报表 -->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form ref="refSearchForm" @search="onSearch" @reset="resetQuery" :formList="formList">
        <global-select
          slot="warehouseList"
          :value.sync="queryParams.warehouseList"
          selectType="selectMultipleSearch"
          requestApi="/system/lookup/data/likeList"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          :setParams="{ lookupType: '4PL_WAREHOUSE_DESCRIPTION' }"
          searchParam="lookupValue"
          :dropdown-match-select-width="false"
        />
        <global-select
          slot="statusList"
          :value.sync="queryParams.statusList"
          selectType="selectMultipleSearch"
          requestApi="/system/lookup/data/likeList"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          :setParams="{ lookupType: 'WAREHOUSE_ENTRY_PLIAN_STATUS' }"
          searchParam="lookupValue"
          :dropdown-match-select-width="false"
        />
        <a-select allowClear slot="dateType" v-model="queryParams.dateType">
          <a-select-option value="库存">库存</a-select-option>
          <a-select-option value="工单">工单</a-select-option>
        </a-select>
        <global-select
          slot="areaNameList"
          :value.sync="queryParams.areaNameList"
          selectType="selectMultiple"
          requestApi="/mes/mesWarehouseEntryPlan/areaNameBox"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <a-button type="primary" @click="handleGenerateData" :loading="btnLoadingObj.genBtn" v-hasPermi="['mes:mesWarehouseEntryPlan:generateData']">生成数据</a-button>
        <a-button type="primary" @click="handlePushAll" :loading="btnLoadingObj.pushAllBtn" v-hasPermi="['mes:mesWarehouseEntryPlan:pushAll']">批量推送</a-button>
        <a-button type="primary" @click="handleExport" :loading="btnLoadingObj.exportBtn" v-hasPermi="['mes:mesWarehouseEntryPlan:export']">导出</a-button>
        <a-button type="primary" @click="handleRefresh" :loading="btnLoadingObj.refreshBtn" v-hasPermi="['mes:mesWarehouseEntryPlan:refresh']">更新数据</a-button>
        <a-button type="primary" @click="handleAddBtnClick">新增</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.WAREHOUSE_ALLOCATION_PLAN_LIST, // 表格方案配置唯一值
              }"
        >
          <template slot="planInboundQuantity" slot-scope="{ text, record }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input-number :min="0" :max="tempMaxPlanInboundQuantity" v-if="isEdit && currentId === record.id" v-model="record.planInboundQuantity" />
          </template>
          <template #deliveryDateTitle>
            <span>计划入库日期</span>
            <a-icon class="action-icon" @click.stop="onEditDate" type="edit" title="编辑"/>
          </template>
          <template slot="deliveryDate" slot-scope="{ text, record }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-date-picker v-else v-model="record.deliveryDate" value-format="YYYY-MM-DD" :disabled-date="disabledDate"/>
          </template>
          <template #showDay="{ text, record }">
            <span v-if="record.dateType==='库存'">{{ "/" }}</span>
            <span v-else>{{ text && $moment(text).format('YYYY-MM-DD') }}</span>
          </template>
          <span slot="operation" slot-scope="{ record }">
            <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['mes:mesWarehouseEntryPlan:generateData']">编辑</a>
            <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
            <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
          </span>
          <!--工单入库数量-->
          <template #quantityCompleted="{ text, record }">
            <span v-if="record.dateType==='库存'">{{ "/" }}</span>
            <span v-else>{{ record.quantityCompleted }}</span>
          </template>
          <!--工单未入库数量-->
          <template #quantityRemaining="{ text, record }">
            <span v-if="record.dateType==='库存'">{{ "/" }}</span>
            <span v-else>{{ record.quantityRemaining }}</span>
          </template>
          <!--供方库存数量-->
          <template #supplierInventoryQty="{ text, record }">
            <span v-if="record.dateType==='工单'">{{ "/" }}</span>
            <span v-else>{{ record.supplierInventoryQty }}</span>
          </template>
          <!--装车数量-->
          <template #loadingQuantity="{ text, record }">
            <span v-if="record.warehouse==='JDC001'">{{ "/" }}</span>
            <span v-else>{{ record.loadingQuantity }}</span>
          </template>
        </ls-api-table>
        <warehouse-allocation-plan-add ref="warehouseAllocationPlanAdd" @handle-success="handleOk"/>
        <batch-edit-delivery-date-modal ref="batchEditDeliveryDateModal" @click="handleOk"/>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiGetMesWarehouseEntryPlanList, apiGenerateData, apiMesWarehouseEntryPlanPushAll, apiMesWarehouseEntryPlanRefresh, apiMesWarehouseEntryPlanUpdateData } from '@/api/mes/scheduling-plan/warehouse-allocation-plan'
import { generateLsTableResData } from '@/utils/util.js'
import warehouseAllocationPlanAdd from './components/warehouse-allocation-plan-add.vue'
import moment from 'moment'
import cacheSearch from '@/mixins/cacheSearch'
import BatchEditDeliveryDateModal from './components/batch-edit-delivery-date-modal'

export default {
  // eslint-disable-next-line
  name: 'Warehouse-allocation-plan', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { warehouseAllocationPlanAdd, BatchEditDeliveryDateModal },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  mixins: [cacheSearch],
  data() {
    return {
      isEdit: false,
      currentId: undefined,
      tempMaxPlanInboundQuantity: 0,
      selectedRows: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetMesWarehouseEntryPlanList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        supplierId: undefined,
        tenantId: undefined,
        skuKey: undefined,
        skuName: undefined,
        attr03: '0',
        attr09: undefined,
        lotKey: undefined,
        dateType: undefined,
        warehouseList: []
      },
      // 表格数据
      tableList: [],
      formList: [
        {
          label: '计划入库日期',
          type: 'range',
          decorator: ['deliveryDate'],
          disposeFormat: {
            staDeliveryDate: (change) => {
              return change[0].format('YYYY-MM-DD')
            },
            endDeliveryDate: (change) => {
              return change[1].format('YYYY-MM-DD')
            }
          }
        },
        {
          label: '工单号',
          decorator: ['wipEntityName'],
          type: 'input'
        },
        {
          label: '入库仓库',
          decorator: ['warehouseList'],
          type: 'warehouseList'
        },
        {
          label: '供应商名称',
          decorator: ['supplierName'],
          type: 'input'
        },
        {
          label: '物料编码',
          decorator: ['itemCode'],
          type: 'input'
        },
        {
          label: '版本号',
          decorator: ['version'],
          type: 'input'
        },
        // {
        //   label: '历史未结工单',
        //   decorator: [''],
        //   type: 'input'
        // },
        {
          label: '状态',
          decorator: ['statusList'],
          type: 'statusList'
        },
        {
          label: '数据类型',
          decorator: ['dateType'],
          type: 'dateType'
        },
        {
          label: '存放区域',
          decorator: ['areaNameList'],
          type: 'areaNameList'
        },
        {
          label: '计划完成时间',
          type: 'range',
          decorator: ['scheduledCompletionDate'],
          disposeFormat: {
            staScheduledCompletionDate: (change) => {
              return change[0].format('YYYY-MM-DD')
            },
            endScheduledCompletionDate: (change) => {
              return change[1].format('YYYY-MM-DD')
            }
          }
        },
        {
          label: '未完成数量交期',
          type: 'range',
          decorator: ['estimatedDeliveryDate'],
          disposeFormat: {
            staEstimatedDeliveryDate: (change) => {
              return change[0].format('YYYY-MM-DD')
            },
            endEstimatedDeliveryDate: (change) => {
              return change[1].format('YYYY-MM-DD')
            }
          }
        }
      ],
      // 表格字段
      columns: [
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          width: 140,
          ellipsis: true,
          stickyFixed: "left"
        },
        {
          title: '数据类型',
          dataIndex: 'dateType',
          align: 'center',
          width: 90,
          ellipsis: true,
          stickyFixed: "left"
        },
        {
          title: '总入库数量',
          dataIndex: 'totalInboundQuantity',
          scopedSlots: { customRender: 'totalInboundQuantity' },
          align: 'center',
          width: 105,
          ellipsis: true,
          stickyFixed: "left"
        },
        {
          title: '计划入库数量',
          dataIndex: 'planInboundQuantity',
          scopedSlots: { customRender: 'planInboundQuantity' },
          align: 'center',
          width: 110,
          ellipsis: true,
          stickyFixed: "left"
        },
        {
          title: '入库仓库',
          dataIndex: 'warehouseName',
          align: 'center',
          width: 100,
          ellipsis: true,
          stickyFixed: "left"
        },
        {
          // title: '计划入库日期',
          customTitle: '计划入库日期',
          dataIndex: 'deliveryDate',
          scopedSlots: { customRender: 'deliveryDate', title: 'deliveryDateTitle' },
          align: 'center',
          width: 130,
          ellipsis: true,
          stickyFixed: "left"
        },
        {
          title: '工单号',
          dataIndex: 'wipEntityName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '计划完成时间',
          dataIndex: 'scheduledCompletionDate',
          scopedSlots: { customRender: 'showDay' },
          align: 'center',
          width: 140,
          ellipsis: true
        },
        {
          title: '未完成数量交期',
          dataIndex: 'estimatedDeliveryDate',
          scopedSlots: { customRender: 'showDay' },
          align: 'center',
          width: 140,
          ellipsis: true
        },
        {
          title: '供应商',
          dataIndex: 'supplierName',
          align: 'center',
          width: 170,
          ellipsis: true
        },
        {
          title: '存放区域',
          dataIndex: 'areaName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center',
          width: 140,
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          width: 250,
          ellipsis: true
        },
        {
          title: '工单入库数量',
          dataIndex: 'quantityCompleted',
          align: 'center',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: "quantityCompleted" }
        },
        {
          title: '工单未入库数量',
          dataIndex: 'quantityRemaining',
          align: 'center',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: "quantityRemaining" }
        },
        {
          title: '供方库存数量',
          dataIndex: 'supplierInventoryQty',
          align: 'center',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: "supplierInventoryQty" }
        },
        {
          title: '拉货数量',
          dataIndex: 'receivedQuantity',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '装车数量',
          dataIndex: 'loadingQuantity',
          align: 'center',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: "loadingQuantity" }
        },
        {
          title: '4PL入库数量',
          dataIndex: 'fplLnventoryQuantity',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '托套比',
          dataIndex: 'palletStandardQty',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '卡板数',
          dataIndex: 'palletQty',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '客审未货审订单',
          dataIndex: 'ungaudOrdersQty',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '当天欠货数',
          dataIndex: 'currentQhQty',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '5天欠货数',
          dataIndex: 'backlog5',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '10天欠货数',
          dataIndex: 'backlog10',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '15天欠货数',
          dataIndex: 'backlog15',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '20天欠货数',
          dataIndex: 'backlog20',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '25天欠货数',
          dataIndex: 'backlog25',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '30天欠货数',
          dataIndex: 'backlog30',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '版本',
          dataIndex: 'version',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '状态',
          dataIndex: 'statusName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 160,
          align: 'center'
        },
        {
          title: '更新人',
          dataIndex: 'updateName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: 160,
          align: 'center'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      btnLoadingObj: {
        genBtn: false,
        pushAllBtn: false,
        refreshBtn: false,
        exportBtn: false
      }
    }
  },
  mounted() {
    if (this.$route.query && Object.keys(this.$route.query).length > 0) {
      this.searchByRoute()
    }else{
      // 处理缓存逻辑
      this.getHistoryCache(
        'refSearchForm',
        '',
        {
          deliveryDate: ['staDeliveryDate', 'endDeliveryDate'],
          scheduledCompletionDate: ['staScheduledCompletionDate', 'endScheduledCompletionDate'],
          estimatedDeliveryDate: ['staEstimatedDeliveryDate', 'endEstimatedDeliveryDate']
        }
      )
      this.onSearch()
    }
  },
  activated() {
    if (this.$route.query && Object.keys(this.$route.query).length > 0) {
      this.searchByRoute()
    }else{
      this.onSearch()
    }
  },
  methods: {
    moment,
    searchByRoute () {
      const { deliveryDate, warehouseCode, materialNo, version } = this.$route.query
      this.queryParams.warehouseList = warehouseCode ? [warehouseCode] : []
      this.$refs.refSearchForm.form.setFieldsValue({
        deliveryDate: [this.$moment(deliveryDate), this.$moment(deliveryDate)],
        version: version || undefined,
        itemCode: materialNo
      })
      this.$nextTick(() => {
        this.$refs.refSearchForm.handleSearch()
      })
    },
    disabledDate(current) {
      // 禁用今天之前的日期
      return moment(current).add(1, 'day') < new Date()
    },
    // 表单搜索
    onSearch(value = {}) {
      const params = {
        ...this.queryParams,
        ...value
      }
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      if (params.attr03.toString() === '0') {
        delete params.attr03
      }
      this.$refs.dataTable.searchParams = params
      this.$refs.dataTable.getData()
    },
    // 新增/修改框事件
    handleOk() {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        organizationCode: undefined,
        tenantId: undefined,
        skuKey: undefined,
        skuName: undefined,
        attr03: '0',
        attr09: undefined,
        lotKey: undefined,
        dateType: undefined
      }
    },
    // 搜索框展开、收起
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 生成数据按钮
    handleGenerateData () {
      this.$confirm({
        title: '提示',
        content: `确定要生成数据吗?`,
        cancelText: '取消',
        onOk: () => {
          this.btnLoadingObj.genBtn = true
          apiGenerateData().then(res => {
            if (res.code === 200) {
              this.$message.success('生成成功!')
              this.onSearch()
            } else {
              this.$message.error(res.msg)
            }
          }).finally(() => {
            this.btnLoadingObj.genBtn = false
          })
        }
      })
    },
    // 批量推送按钮
    handlePushAll () {
      this.$confirm({
        title: '提示',
        content: `确定要批量推送吗?`,
        cancelText: '取消',
        onOk: () => {
          this.btnLoadingObj.pushAllBtn = true
          apiMesWarehouseEntryPlanPushAll().then(res => {
            if (res.code === 200) {
              this.$message.success('推送成功!')
              this.onSearch()
            } else {
              this.$message.error(res.msg)
            }
          }).finally(() => {
            this.btnLoadingObj.pushAllBtn = false
          })
        }
      })
    },
    // 更新数据按钮
    handleRefresh () {
      this.btnLoadingObj.refreshBtn = true
      apiMesWarehouseEntryPlanRefresh().then(res => {
        if (res.code === 200) {
          this.$message.success('更新成功!')
          this.onSearch()
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
        this.btnLoadingObj.refreshBtn = false
      })
    },
    handleExport () {
      this.btnLoadingObj.exportBtn = true
      const params = {
        ...this.queryParams,
        ...this.$refs.refSearchForm.getSearchValue()
      }
      delete params.searchFormLabel
      if (params.attr03.toString() === '0') {
        delete params.attr03
      }
      this.download('mes/mesWarehouseEntryPlan/export', {
        ...params
      }, `分仓入库计划_${new Date().getTime()}.xlsx`).finally(() => {
        this.btnLoadingObj.exportBtn = false
      })
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.tempMaxPlanInboundQuantity = record.planInboundQuantity
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      if (!record.planInboundQuantity && record.planInboundQuantity !== 0) {
        this.$message.warning('计划入库数量不能为空')
        return;
      }
      if (!record.deliveryDate) {
        this.$message.warning('计划入库日期不能为空')
        return;
      }
      delete record.createTime
      delete record.createName
      delete record.updateName
      delete record.updateTime
      apiMesWarehouseEntryPlanUpdateData(record).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.onSearch()
          this.isEdit = false;
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch()
    },
    handleAddBtnClick () {
      this.$refs.warehouseAllocationPlanAdd.show()
    },
    // 批量更新计划入库日期
    onEditDate() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请勾选单据进行修改")
      }
      let flag = false
      for (const item of this.selectedRows) {
        if(item.status !== '1') {
          flag = true
          break
        }
      }
      if(flag) {
        return this.$message.warning("请选择状态为新建的单据")
      }
      this.$refs.batchEditDeliveryDateModal.show(this.selectedRows)
    }
  }
}
</script>

<style scoped lang="less">
.page-header-content {
  /deep/.ant-input-number {
    width: 100%;
  }
}
.action-icon{
  cursor: pointer;
  font-size: 14px;
  color: #0486fe;
}
</style>
